import { useNavigate } from 'react-router-dom';
import { useMutation } from '@tanstack/react-query';
import { authApi } from '../services/api/auth';
import { api } from '../services/api/client';
import { useUser } from './useUser';

export const useLogout = () => {
  const navigate = useNavigate();
  const { clearUser } = useUser();

  const mutation = useMutation({
    mutationFn: () => authApi.logout(),
    onSettled: () => {
      api.removeToken();
      clearUser();
      navigate('/login');
    },
  });

  const handleLogout = () => {
    mutation.mutate();
  };

  return { handleLogout };
};
